module.exports = __webpack_public_path__ + "img/DSC_0635.f8fea80d.jpg";